import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-8 mb-5 mb-xl-10" }
const _hoisted_2 = { class: "col-xxl-4" }
const _hoisted_3 = { class: "col-xxl-4" }
const _hoisted_4 = { class: "col-xxl-4" }
const _hoisted_5 = { class: "row gy-5 gx-xl-8" }
const _hoisted_6 = { class: "row gy-5 gx-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerDashboardContentLoader = _resolveComponent("CustomerDashboardContentLoader")!
  const _component_CustomerWidgetOrders = _resolveComponent("CustomerWidgetOrders")!
  const _component_WidgetCustomerOrdersDaily = _resolveComponent("WidgetCustomerOrdersDaily")!
  const _component_WidgetCustomerOrdersMonthly = _resolveComponent("WidgetCustomerOrdersMonthly")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_CustomerDashboardContentLoader)
    ], 512), [
      [_vShow, _ctx.loader]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_CustomerWidgetOrders, {
            icon: require('@/assets/media/icons/total-orders.svg'),
            title: 'message.TOTAL_ORDERS',
            link: "/orders",
            getKey: _ctx.widgets_data?.total_order
          }, null, 8, ["icon", "title", "getKey"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_CustomerWidgetOrders, {
            icon: require('@/assets/media/icons/icon-money.svg'),
            title: 'message.TOTAL_SALES',
            link: "/orders",
            background: "lightcyan",
            getKey: _ctx.widgets_data?.total_sales
          }, null, 8, ["icon", "title", "getKey"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_CustomerWidgetOrders, {
            icon: require('@/assets/media/icons/monthly-sales.svg'),
            title: 'message.LAST_ORDER_DATE',
            background: "lightcyan",
            link: "/customer/lists",
            getKey: _ctx.widgets_data?.latest_order
          }, null, 8, ["icon", "title", "getKey"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", null, [
          _createVNode(_component_WidgetCustomerOrdersDaily, {
            "widget-classes": "mb-5 mb-xl-8",
            "chart-color": "primary",
            chartHeight: "350",
            icon: require('@/assets/media/icons/daily-sales.svg'),
            title: 'message.DAILY_SALES',
            titleDescription: 'message.MONTHLY_SALES_BY_DAY',
            uuid: _ctx.uuid,
            background: "lightcyan",
            locale: _ctx.systemLocale,
            key: _ctx.refresh,
            link: "#"
          }, null, 8, ["icon", "title", "titleDescription", "uuid", "locale"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", null, [
          _createVNode(_component_WidgetCustomerOrdersMonthly, {
            "widget-classes": "mb-5 mb-xl-8",
            "chart-color": "primary",
            chartHeight: "300",
            icon: require('@/assets/media/icons/monthly-sales-graph.svg'),
            title: 'message.MONTHLY_SALES',
            titleDescription: 'message.YEARLY_SALES_BY_MONTH',
            uuid: _ctx.uuid,
            background: "lightcyan",
            locale: _ctx.systemLocale,
            key: _ctx.refresh,
            link: "#"
          }, null, 8, ["icon", "title", "titleDescription", "uuid", "locale"])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.loader]
    ])
  ], 64))
}